import { toast } from 'sonner'

import { parseError } from '@/lib/errors'

/** True once the step saved, false after showing why it didn't: what a ReasonDialog's onConfirm wants. */
export function confirmStep(step: Promise<unknown>, success: string): Promise<boolean> {
  return step.then(
    () => {
      toast.success(success)
      return true
    },
    (error: unknown) => {
      toast.error(parseError(error))
      return false
    }
  )
}
